import {
  NotFoundErrorPage,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';
import { NotFoundPage } from './NotFoundPage';

/**
 * Replaces the app's built-in 404.
 *
 * `NotFoundErrorPage` is a swappable component rather than a route: the app
 * plugin registers a default under the name `core-not-found-error-page`, and
 * reusing that name from a module on the `app` plugin overrides it. The name
 * has to match exactly - a different one installs a second component that
 * nothing renders.
 */
const notFoundPage = SwappableComponentBlueprint.make({
  name: 'core-not-found-error-page',
  params: define =>
    define({
      component: NotFoundErrorPage,
      loader: () => NotFoundPage,
    }),
});

export const errorsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [notFoundPage],
});
